// EmptyState.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import EmptyStateIllustration from './EmptyStateIllustration';

const EmptyState = ({ 
  title = "No data available", 
  description = "There's nothing to display here yet.", 
  // illustration,
  icon,
  actionText,
  onAction 
}) => {
  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      p: 4,
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 2,
      backgroundColor: 'background.paper'
    }}>
      {/* {illustration || <EmptyStateIllustration />} */}
      {icon && (
        <Box sx={{ color: 'text.secondary', fontSize: 64, mb: 2 }}>
          {icon}
        </Box>
      )}
      <Typography variant="h6" color="text.secondary" gutterBottom sx={{ mt: 2 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
      {actionText && (
        <Button 
          variant="outlined" 
          color="primary"
          onClick={onAction}
        >
          {actionText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
